export default "__VITE_ASSET__549fd1f6__"